// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"7bb42a72","498":"8e407bf1","513":"3ffc46e9","703":"940f0f2b"}[chunkId] + ".chunk.js";
};